(() => {
  const update = () => document.querySelectorAll('.custom-product-title-share-v1').forEach((row) => {
    const heading = row.querySelector('h1');
    if (!heading) return;
    const style = getComputedStyle(heading);
    const context = document.createElement('canvas').getContext('2d');
    context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    const reference = 'Purple Flower Girl Dress with Illusion Bodice';
    const spacing = parseFloat(style.letterSpacing) || 0;
    const referenceWidth = Math.ceil(context.measureText(reference).width + spacing * (reference.length - 1)) + 1;
    const availableWidth = row.querySelector('.custom-product-title-share-v1__text').getBoundingClientRect().width;
    const originalWidth = Math.min(referenceWidth, availableWidth);
    const previousWidth = originalWidth + Math.max(0, availableWidth - originalWidth) / 2;
    const titleWidth = previousWidth + Math.max(0, availableWidth - previousWidth) * 0.4;
    row.style.setProperty('--custom-title-line-width', `${titleWidth}px`);
  });
  document.fonts.ready.then(update);
  window.addEventListener('resize', update);
  document.addEventListener('shopify:section:load', update);
})();
